'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/6/27.
                                   */

// import { asyncConnect } from 'redux-async-connect';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _components = require('components');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 @asyncConnect([ {
 promise: ({store: {dispatch}}) => {
 return dispatch(authActions.getUserInfo());
 }
 } ])*/
var PersonalCenterDefault = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    infoChangeData: state.auth.infoChangeData,
    infoChanging: state.auth.infoChanging,
    infoChangeModalOpened: state.auth.infoChangeModalOpened,
    userInfo: state.auth.userInfo
  };
}, authActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PersonalCenterDefault, _Component);

  function PersonalCenterDefault() {
    (0, _classCallCheck3.default)(this, PersonalCenterDefault);

    // 这里为日期控件测试代码
    // 本地化日期

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(PersonalCenterDefault).call(this));

    _moment2.default.locale('zh-cn');
    _this.state = {
      // 是否显示测试日期控件
      isShowDate: false,
      // moment为处理日期的库，用moment将字符串转换为moment有效值
      date: (0, _moment2.default)('2016/09/10', 'YYYY-MM-DD')
    };
    return _this;
  }

  (0, _createClass3.default)(PersonalCenterDefault, [{
    key: 'onChangeInfo',
    value: function onChangeInfo() {
      var _props = this.props;
      var openChangeInfoModal = _props.openChangeInfoModal;
      var addressInfo = _props.addressInfo;
      var userInfo = _props.userInfo;
      var info = userInfo.info;

      var defValue = '';
      var level = 'one';
      if (info instanceof Array && info.length > 0) {
        defValue = info[0].city;
        if (defValue) {
          level = 'three';
        }
      }
      if (openChangeInfoModal) {
        addressInfo({
          value: '',
          defValue: defValue,
          firstfilter: '',
          datafilter: ''
        }, level).then(function () {
          openChangeInfoModal();
        });
      }
    }
  }, {
    key: 'onSubmitChangeInfo',
    value: function onSubmitChangeInfo(submitData) {
      var _props2 = this.props;
      var infoChangeSubmit = _props2.infoChangeSubmit;
      var userInfo = _props2.userInfo;
      var clearInfoChangeData = _props2.clearInfoChangeData;
      var getUserInfo = _props2.getUserInfo;

      var initialValues = {};
      if (userInfo) {
        var info = userInfo.info;

        if (info instanceof Array && info.length > 0) {
          initialValues = (0, _extends3.default)({}, info[0]);
          if (infoChangeSubmit) {
            infoChangeSubmit((0, _extends3.default)({}, initialValues, submitData, { effectiveTag: '3' })).then(function (resultData) {
              if (resultData.isValid === true) {
                clearInfoChangeData();
                getUserInfo();
              }
            });
          }
        }
      }
    }
  }, {
    key: 'onCloseInfoModal',
    value: function onCloseInfoModal() {
      var clearInfoChangeData = this.props.clearInfoChangeData;

      if (clearInfoChangeData) {
        clearInfoChangeData();
      }
    }
  }, {
    key: 'onAddressChange',
    value: function onAddressChange(value, level) {
      var addressInfo = this.props.addressInfo;

      if (addressInfo) {
        addressInfo({
          value: value,
          defValue: '',
          firstfilter: '',
          datafilter: ''
        }, level);
      }
    }

    // 这里为日期控件测试代码

  }, {
    key: 'onBirthDayChange',
    value: function onBirthDayChange(val) {
      // console.log(val.format('YYYY/MM/DD'));
      this.setState({ date: val });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var userInfo = _props3.userInfo;
      var infoChangeModalOpened = _props3.infoChangeModalOpened;
      var infoChangeData = _props3.infoChangeData;
      var infoChanging = _props3.infoChanging;
      // 这里为日期控件测试代码
      // 本地化日期

      _moment2.default.locale('zh-cn');
      // 结束
      var _state = this.state;
      var isShowDate = _state.isShowDate;
      var date = _state.date;

      var realUser = {};
      var addressDataInfo = {};
      var bottomDiv = '';
      if (userInfo) {
        var info = userInfo.info;
        var addressData = userInfo.addressData;

        if (info instanceof Array && info.length > 0) {
          realUser = info[0];
        } else {
          bottomDiv = _react2.default.createElement(_components.ErrorLabel, { error: '会员数据不正确' });
        }
        if (addressData) {
          addressDataInfo = addressData;
        }
      }

      var submitError = '';
      if (infoChangeData && infoChangeData.isValid === false) {
        submitError = infoChangeData.message;
      }
      var styles = require('./PersonalCenterDefault.scss');
      return _react2.default.createElement(
        'dl',
        { className: styles.component },
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '姓名', value: realUser.name }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '上级会员', value: realUser.topMember }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '性别', value: realUser.gender }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '昵称', value: realUser.nickName }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '邮箱', value: realUser.email }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '联系电话', value: realUser.mobile }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '所在城市', value: realUser.cityName }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '微信号', value: realUser.wechatId }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '教育程度', value: realUser.education }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.GoeasyDisplayField, { label: '出生日期', value: realUser.birthday }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.SubmitBtn, { text: '修改', btnClick: this.onChangeInfo.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),

        /* 这里为日期控件测试代码
           moment 为处理日期的库
           withPortal 弹出还是下拉 默认false为下拉
         displayFormat 展示在input框内的日期格式
         isOutsideRange 函数类型 是否允许选择当前日期之前的日期 默认为不允许()=>true
         initialVisibleMonth 第一次弹出日期选择的时候 所在月份
         date 值 即 value
         monthFormat 在日期框内显示月份的格式 上面这行代码moment.locale('zh-cn')；就是为了中文显示月份
         dateChange 日期改变事件
         phrases 本地化，中文显示
        * */
        isShowDate ? _react2.default.createElement(
          'div',
          { style: { width: 300, zIndex: 15 } },
          _react2.default.createElement(_components.GoeasyDatePicker, { id: 'birthday', phrases: { closeDatePicker: '关闭' }, placeholder: '出生日期', withPortal: true,
            displayFormat: 'YYYY/MM/DD', initialVisibleMonth: function initialVisibleMonth() {
              return date;
            }, isOutsideRange: function isOutsideRange() {
              return false;
            },
            dateChange: this.onBirthDayChange.bind(this), date: date, monthFormat: 'YYYY[年]MMMM' })
        ) : '',
        _react2.default.createElement('div', { className: 'clear' }),
        bottomDiv,
        _react2.default.createElement(_components.ChangeInfoModal, { isOpened: infoChangeModalOpened, initialValues: realUser,
          addressData: addressDataInfo, submitError: submitError,
          changing: infoChanging, onClose: this.onCloseInfoModal.bind(this),
          info: realUser, onAddressChange: this.onAddressChange.bind(this),
          onSubmit: this.onSubmitChangeInfo.bind(this) })
      );
    }
  }]);
  return PersonalCenterDefault;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  infoChangeSubmit: _react.PropTypes.func,
  getUserInfo: _react.PropTypes.func,
  addressInfo: _react.PropTypes.func,
  openChangeInfoModal: _react.PropTypes.func,
  clearInfoChangeData: _react.PropTypes.func,
  infoChangeModalOpened: _react.PropTypes.bool,
  infoChangeData: _react.PropTypes.object,
  infoChanging: _react.PropTypes.bool,
  userInfo: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PersonalCenterDefault;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenterDefault/PersonalCenterDefault.js
 ** module id = 1521
 ** module chunks = 0
 **/